// extracted by mini-css-extract-plugin
module.exports = {"price-description":"_1th8On","header":"_2l8Kr8","plus-price-details":"_2A1LBk","coin-icon":"_3B1jKS"};